//
//
//
//
//
//
//

export default {
    props: {
        uuid: {
            required: true
        },
        readonly: {
            type: Boolean
        },
        value: Boolean
    },
    data() {
        return {
            checked: false
        };
    },
    computed: {
        computedValue: {
            get() {
                return this.value || false;
            },
            set(v) {
                this.$emit("input", v);
            }
        }
    }
};

